// Hardcoded UTM source -> medium mapping for Captain app campaigns.
// Per product spec, options and mappings are NOT editable in-app; they change only
// through engineering releases. The UTM source dropdown offers exactly these 45 sources,
// and the UTM medium dropdown offers exactly the mediums mapped to the selected source.
export const CAMPAIGN_UTM_SOURCE_MEDIUMS: { [source: string]: string[] } = {
  abandoned_cart: ['email', 'sms'],
  affiliate: ['affiliate'],
  angi: ['local_listing'],
  apple_maps: ['local_listing'],
  beyond_the_bin: ['local_listing'],
  bing: ['organic_search'],
  bing_places: ['local_listing'],
  charity: [
    'marketing_kit',
    'referral',
    'phone',
    'qr_code',
    'flyer',
    'email',
    'saas',
    'postcard',
    'poster',
    'partner_social',
    'staff_training',
    'window_poster',
    'new_partner',
  ],
  charity_partner: ['partner_email'],
  'chatgpt.com': ['ai_referral'],
  'copilot.com': ['ai_referral'],
  courier: ['flyer'],
  craigslist: ['classified_listing'],
  creator: ['influencer'],
  earth911: ['local_listing'],
  email: ['lifecycle_email', 'b2b_realtor', 'newsletter', 'remarketing'],
  google: ['paid_demand_gen', 'paid_display', 'paid_lsa', 'paid_pmax', 'paid_search', 'organic_search', 'organic_video', 'sitelink'],
  google_business_profile: ['local_listing'],
  government: ['municipal_referral'],
  hauler: ['door_magnet', 'business_card', 'qr_code'],
  linkedin: ['paid_social', 'organic_social'],
  meta: ['paid_social', 'organic_social'],
  microsoft: ['paid_native', 'paid_pmax', 'paid_search'],
  municipality: ['municipal_referral'],
  nextdoor: ['local_listing'],
  offline: [
    'a_frame',
    'billboard',
    'business_card',
    'b2b_direct_mail',
    'b2c_direct_mail',
    'b2b_event',
    'b2c_event',
    'b2b_flyer',
    'b2c_flyer',
    'in_store_screen',
    'print_magazine',
    'b2b_qr_code',
    'b2c_qr_code',
    'truck_wrap',
    'b2b_signage',
    'b2c_signage',
    'resupply-brand',
    'ivr',
  ],
  partner_portal: ['referral'],
  perplexity: ['ai_referral'],
  pinterest: ['paid_social'],
  podcast: ['audio_referral'],
  publication: ['pr_referral'],
  push: ['push'],
  radio: ['offline_audio', 'wgbh'],
  realtor_partner: ['b2b_event', 'b2b_flyer', 'referral'],
  reddit: ['organic_social', 'paid_social'],
  sms: ['sms'],
  stackadapt: ['paid_native', 'paid_audio', 'paid_ctv', 'paid_display'],
  thumbtack: ['local_listing'],
  tiktok: ['organic_social', 'paid_social'],
  trustindex: ['review_site'],
  trustpilot: ['review_site'],
  uber: ['partner_referral'],
  widget: ['partner_widget'],
  yelp: ['local_listing'],
  youtube: ['paid_video'],
};

export const CAMPAIGN_UTM_SOURCES: string[] = Object.keys(CAMPAIGN_UTM_SOURCE_MEDIUMS);

export const campaignUtmMediumsForSource = (source?: string | null): string[] =>
  source ? (CAMPAIGN_UTM_SOURCE_MEDIUMS[source] ?? []) : [];

export const isValidCampaignUtmSource = (source?: string | null): boolean => !!source && !!CAMPAIGN_UTM_SOURCE_MEDIUMS[source];

export const isValidCampaignUtmMedium = (source?: string | null, medium?: string | null): boolean =>
  !!medium && campaignUtmMediumsForSource(source).includes(medium);
